import type { MovementsMenuPermissions } from '@services/MovimentationService';

import type { MovementMenuRedirect, MovementMenuService } from '../types';

function mapRedirects(
  redirects: MovementMenuRedirect[],
  permissions: MovementsMenuPermissions[],
) {
  return redirects.filter(redirect => {
    const thisPermission = permissions?.find(
      permission => permission?.menu === redirect?.enum,
    );
    return Boolean(thisPermission?.display);
  });
}

function mapServices(
  services: MovementMenuService[],
  permissions: MovementsMenuPermissions[],
) {
  return services.map(service => {
    if (service?.primary) {
      return service;
    }

    const redirects = mapRedirects(service?.redirects, permissions);
    return { ...service, redirects };
  });
}

function filterServices(services: MovementMenuService[]) {
  return services.filter(service => {
    if (service?.primary) {
      return true;
    }

    return service?.redirects.length > 0;
  });
}

export function mapAllServices(
  services: MovementMenuService[],
  permissions: MovementsMenuPermissions[],
) {
  const mappedServices = mapServices(services, permissions);

  return filterServices(mappedServices);
}
